import { __awaiter, __generator } from "tslib";
import { parseConfig } from '@office-start/config-parser-utility';
import { getErrorHandler } from '@office-start/error-handler';
import { KnownInstrumentationEvents, } from '@office-start/instrumentation-types';
import { applyOfficeIdentity, httpGet } from '@office-start/xhr-service';
// TODO: Refactor config flow with separate sources for flags, settings, identity, and shell data
var configCache = new Map();
function resolveNetworkConfig(configId, options) {
    return __awaiter(this, void 0, void 0, function () {
        var configUrl, requestConfig, windowSearchParams, scenarioId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (options.disableLegacyNetworkConfigs) {
                        return [2 /*return*/, undefined];
                    }
                    configUrl = new URL("".concat(options.officeHomeApiRoot, "/api/config/").concat(configId), window.location.origin);
                    requestConfig = {};
                    return [4 /*yield*/, applyOfficeIdentity(requestConfig, options.inMockMode, options.workload, options.getIdentity)];
                case 1:
                    _a.sent();
                    if (!!window.location.search) {
                        windowSearchParams = new URLSearchParams(window.location.search);
                        if (!requestConfig.params) {
                            requestConfig.params = {};
                        }
                        if (options.inMockMode) {
                            // Add additional query params for mocks
                            windowSearchParams.forEach(function (value, key) {
                                /* eslint-disable @typescript-eslint/no-non-null-assertion */
                                if (requestConfig.params[key] === undefined) {
                                    requestConfig.params[key] = value;
                                }
                                /* eslint-enable @typescript-eslint/no-non-null-assertion */
                            });
                        }
                        else {
                            // Handle params from other workloads in production
                            if (windowSearchParams.has('scenarioid')) {
                                scenarioId = windowSearchParams.get('scenarioid');
                                /* eslint-disable @typescript-eslint/no-non-null-assertion */
                                requestConfig.params.scenarioid = scenarioId !== null && scenarioId !== void 0 ? scenarioId : '';
                            }
                        }
                    }
                    return [2 /*return*/, httpGet(KnownInstrumentationEvents.ConfigRequest, "Config" /* KnownRequestInstrumentationEvents.ConfigRequest */, configUrl.toString(), requestConfig, options.jwtAuthEnabled, options.getAccessToken, options.officeHomeApiRoot, options.correlationId, 'OfficeHome', {
                            populateRequestEvent: function (_result, params) {
                                params["ElementId" /* InstrumentationParam.ElementId */] = configId;
                            },
                        })
                            .then(function (result) { return result.data; })
                            .catch(function (error) {
                            getErrorHandler().handleError(error);
                            return undefined;
                        })];
            }
        });
    });
}
export function resolveConfig(configId, options) {
    var _this = this;
    if (configCache.has(configId)) {
        return configCache.get(configId);
    }
    var configPromise = new Promise(function (resolve) { return __awaiter(_this, void 0, void 0, function () {
        var resolvedConfig, shellAndConfigResponse, config, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    resolvedConfig = undefined;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    shellAndConfigResponse = window.shellAndConfigResponse;
                    if (!shellAndConfigResponse) return [3 /*break*/, 3];
                    return [4 /*yield*/, shellAndConfigResponse];
                case 2:
                    config = _b.sent();
                    if (config && config[configId]) {
                        try {
                            // While the root config object is an object, each individual config is a JSON-serialized string.
                            resolve(JSON.parse(config[configId]));
                        }
                        catch (_c) {
                            // Some configs are not JSON, so resolve them as is.
                            resolve(config[configId]);
                        }
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    resolvedConfig = parseConfig(configId);
                    if (resolvedConfig) {
                        resolve(resolvedConfig);
                        return [2 /*return*/];
                    }
                    _b.label = 4;
                case 4: return [3 /*break*/, 6];
                case 5:
                    _a = _b.sent();
                    return [3 /*break*/, 6];
                case 6:
                    if (!options) {
                        resolve(undefined);
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, resolveNetworkConfig(configId, options)];
                case 7:
                    resolvedConfig = _b.sent();
                    resolve(resolvedConfig);
                    return [2 /*return*/];
            }
        });
    }); });
    configCache.set(configId, configPromise);
    return configPromise;
}
//# sourceMappingURL=resolveConfig.js.map